import type { ImgHTMLAttributes } from 'react';

import type { SnappyGiftPayload } from '../../stores/rewards/types';

type SnappyGiftRewardProps = {
  snappyGiftPayload: SnappyGiftPayload;
} & ImgHTMLAttributes<HTMLImageElement>;

export function SnappyGiftReward({ snappyGiftPayload, ...imgProps }: SnappyGiftRewardProps) {
  return <img alt="snappy gift" src={snappyGiftPayload.popupImageUrl} {...imgProps} />;
}
